import styled, { css } from 'styled-components';

import { FlexDiv } from 'commonStyles';

export const CardTabs = styled(FlexDiv)`
	border-bottom: ${(p)=>p.$borderBottom || '1px solid #b9b6b6'};
`;

export const TabList = styled.li`
	padding: 8px;
	font-size: 14px;
	line-height: 20px;
	font-weight: 900;
	position: relative;
	width: ${(p)=>p.$width};
	text-align: center;
	${(props) => props.active && css`
	&:after {
		width: 100%;
		height: 3px;
		background: linear-gradient(104.41deg, #FF7E40 0%, #FF405D 99.23%);
		display: inline-block;
		content: '';
		position: absolute;
		bottom: -1px;
		left: 0px;
	}`
}
	
}
`;
